import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "bell, notification, activity, alert" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M13.3332 15.4163C12.7721 16.8879 11.4908 17.9163 9.99984 17.9163C8.5089 17.9163 7.22756 16.8879 6.6665 15.4163M17.0832 15.4163L16.0884 7.45785C15.7045 4.38726 13.0943 2.08301 9.99984 2.08301C6.90536 2.08301 4.29514 4.38726 3.91132 7.45785L2.9165 15.4163H17.0832Z",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }